import { initializeApp } from 'firebase/app'
import { getMessaging } from 'firebase/messaging'

const app = initializeApp(window.appConfig.push_notification.firebase)

export const messaging = getMessaging(app)